import { render, staticRenderFns } from "./BrakediscClassroom5.vue?vue&type=template&id=cc292296&scoped=true"
import script from "./BrakediscClassroom5.vue?vue&type=script&lang=js"
export * from "./BrakediscClassroom5.vue?vue&type=script&lang=js"
import style0 from "./BrakediscClassroom5.vue?vue&type=style&index=0&id=cc292296&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc292296",
  null
  
)

export default component.exports